import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';

@Component({
	selector: 'app-root',
	template: `<app-header-component />
		<router-outlet />
		<app-footer-component /> `,
	imports: [RouterOutlet, HeaderComponent, FooterComponent]
})
export class AppComponent {
	title = 'policies-devere-group';
}
